import React from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import { Header } from "./components/Header";
import { Footer } from "./components/Footer";
import { WhatsAppButton } from "./components/WhatsAppButton";
import { MobileBookingButton } from "./components/MobileBookingButton";
import { Home } from "./pages/Home";
import { About } from "./pages/About";
import { Services } from "./pages/Services";
import { Booking } from "./pages/Booking";
import { Contact } from "./pages/Contact";
import { DiscoveryTest } from "./pages/DiscoveryTest";
import { Legal } from "./pages/Legal";
import { Admin } from "./pages/Admin";
import { LanguageProvider } from "./context/LanguageContext";

const ChromeWhatsApp = () => {
  const location = useLocation();
  if (location.pathname.startsWith("/admin")) return null;
  return <WhatsAppButton />;
};

function App() {
  return (
    <div className="App">
      <LanguageProvider>
        <BrowserRouter>
          <Header />
          <ChromeWhatsApp />
          <MobileBookingButton />
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/about" element={<About />} />
            <Route path="/services" element={<Services />} />
            <Route path="/booking" element={<Booking />} />
            <Route path="/contact" element={<Contact />} />
            <Route path="/test" element={<DiscoveryTest />} />
            <Route path="/confidentialite" element={<Legal doc="privacy" />} />
            <Route path="/mentions-legales" element={<Legal doc="notice" />} />
            <Route path="/admin" element={<Admin />} />
          </Routes>
          <Footer />
        </BrowserRouter>
      </LanguageProvider>
    </div>
  );
}

export default App;

